// Select all elements with the class .loschlegal-counter
const customFields = document.querySelectorAll('.loschlegal-counter');

// Check if any elements are found
if (customFields.length) { 
    customFields.forEach(field => {
        // Set up an Intersection Observer to check if the element is in the viewport
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // Get the text directly from the span element when it's in the viewport
                    let text = entry.target.textContent.trim();

                    if (text) {
                        // Remove commas but leave the decimal intact
                        let number = text.replace(/,/g, '');

                        // Check if it's a valid number and not NaN
                        if (!isNaN(number)) {
                            animateCount(entry.target, number, 3000); // Animate each number for 3 seconds
                        }
                    }
                    // Stop observing once the element is in the viewport and the animation starts
                    observer.unobserve(entry.target);
                }
            });
        }, { threshold: 0.5 }); // 50% of the element needs to be in view

        observer.observe(field); // Start observing the current field
    });
}

// Function to animate the count over a specified duration
function animateCount(element, targetNumber, duration) {
    let currentNumber = 0;
    let isDecimal = targetNumber.includes('.'); // Check if the number has a decimal point

    let stepTime = 30; // 30ms per frame (~33fps)
    let steps = duration / stepTime; // Total steps

    // If it's a decimal, increment by 0.1; otherwise, increment by the integer steps
    let increment = isDecimal 
        ? (targetNumber / steps).toFixed(1)  // Smaller decimal steps for decimals
        : Math.ceil(targetNumber / steps);  // Integer steps for whole numbers

    increment = parseFloat(increment); // Ensure increment is a number

    let interval = setInterval(() => {
        currentNumber += increment;

        // Avoid overshooting the target
        if (currentNumber >= targetNumber) {
            currentNumber = targetNumber;
            clearInterval(interval);
        }

        // Format the number properly
        if (isDecimal) {
            // Always show one decimal place (even for 5.0)
            element.textContent = currentNumber.toFixed(1);
        } else {
            // Show commas for large integers
            element.textContent = Math.floor(currentNumber).toLocaleString();
        }
    }, stepTime);
}